import React from 'react';

import Cookies from 'js-cookie';

import axios from 'axios';

// import customProtocolCheck from "custom-protocol-check";

import {customProtocolCheck} from './checkProtocol';

import {history} from '../../../store';

import {ToolboxStatistic} from '../../Utility/ToolboxStatistic/toolboxStatistic';

const getURL = () => process.env.API_URL+"/api";

let isDownloadingTT = false;

const tourstartDownload = (data_type) => {
    const callback = () => {
        window.open(`${process.env.API_URL}/ajax/gps/downloadInstallTourstartApp`, '_self');
    }
    if(!isDownloadingTT){
        isDownloadingTT = true;
        setTimeout(function () {
            isDownloadingTT = false;                
        }, 2000);
        ToolboxStatistic.increase(data_type, callback); 
        Cookies.set("InstalledTT", true, { expires: 365, path: '/' })
    }
}


const downloadDataClick = (data_type, pc) => {
        if(pc){
            downloadData(data_type);
        }else{
        switch(data_type){
           case 'Garmin':__downloadToGarmin();
               break;
           case 'navigonfresh':
               navigonDownload();
               break;
           case 'TourstartTransfer':
               tourstartDownload(data_type);
               break;
           default:
               downloadData(data_type)
               break;
        }
        }
}

export const onDownloadDataClick = (data_type, pc) => { //need to keep only downloadDataClick(data_type, pc);
    if(data_type == 'TourstartTransfer'){
        downloadDataClick(data_type);
    }else{
        axios({
            url: `${getURL()}/gps.checkUser`,
            method: 'GET',
            withCredentials: true,
        }).then(res => {
            const {code, response} = res.data;
            if(code === 200){
                axios({
                    url: `${getURL()}/gps.checkLimits?type=gps`,
                    method: 'GET',
                    withCredentials: true,
                }).then(res => {
                    const {code, response} = res.data;
                    if(code === 200){
                        downloadDataClick(data_type, pc);
                    } else {
                        history.push("/pro");
                    }
                })
            } else {
                console.log('need login');
            } 
        });
    }

}


const _checkProtocol = (url) => {
        axios({
            url: `${getURL()}/gps.checkTransferdata?check=go`,
            method: 'GET',
            withCredentials: true,
        }).then(res => {
            const {code, response} = res.data;
            if(code === 200){
                const failCb = () => {
                }
                const successCb = () => {
                    onDownloadDataClick('TourstartTransfer');
                }
                customProtocolCheck(url, failCb, successCb);
            } else {
                history.push("/pro");
            }
        })
    }

const startCheckingInstalledTT = url => {
    const failCb = () => {
        // console.log('ffffffffffffffffffffffffffff');
    }

    const successCb = () => {
        // console.log('ssssssssssssssssssssssssssss');
    }
    customProtocolCheck(url, failCb, successCb);
}



export const initListenerForTourstartTransfer = (url) => {
    startCheckingInstalledTT(url);

    //     const keyTT = Cookies.get('transferTourstartOn');
    //     if(keyTT){
    //         axios({
    //             url: `${getURL()}/gps.isExistsTT?keytt=${keyTT}`,
    //             method: 'GET',
    //         }).then(res => {
    //             const {code, response} = res;
    //             if(code != 200){
    //                 Cookies.set('transferTourstartOn', "",{ expires: 0, path: '/' });
    //                 startCheckingInstalledTT(url)              
    //             }
    //             // _checkProtocol(url);
    //         })
    //         .catch(() => startCheckingInstalledTT(url));
    //         // .finally(() => startCheckingInstalledTT(url));
    //     }else{
    //         // _checkProtocol(url);
    //         startCheckingInstalledTT(url);
    //     }

    // // }
}
